/**
 * Las versiones vigentes de los documentos legales de TBit Jobs.
 *
 * COPIA de `lib/termsVersions.ts` de job-apply-service, que es la que manda: el
 * servidor rechaza (400) una aceptación que no sea de SU versión vigente. Los
 * tests de los dos repos fijan el valor literal: cambiar una es cambiar la otra,
 * en el mismo despliegue (y el texto publicado en tbit.app, que imprime
 * «Versión AAAA-MM-DD»).
 *
 * Si el servidor ya va por otra versión (este bundle quedó viejo en el
 * navegador), contesta `terms_outdated` con `current_version`: la pantalla
 * adopta esa, desmarca la casilla y vuelve a preguntar (`readTermsError`).
 */

/** Términos y condiciones de TBit Jobs (candidatos y agencias). */
export const TBIT_JOBS_TERMS_VERSION = '2026-10-13';

/** Términos del Programa de socios de TBit Jobs. */
export const PARTNER_TERMS_VERSION = '2026-10-08';

export type TermsDoc = 'tbit_jobs' | 'partner';

/** Lo que viaja en el cuerpo del pedido cuando la casilla está marcada. */
export interface TermsAcceptanceBody {
  terms_accepted: true;
  terms_version: string;
}

export function termsAcceptanceBody(version: string): TermsAcceptanceBody {
  return { terms_accepted: true, terms_version: version };
}

/** Lo que dice el servidor de si alguien aceptó la versión vigente (socio, agencia). */
export interface TermsStatus {
  doc: TermsDoc;
  version: string;
  accepted_version: string | null;
  accepted: boolean;
}

export type TermsErrorCode = 'terms_required' | 'terms_outdated';

export interface TermsError {
  code: TermsErrorCode;
  /** La versión vigente según el servidor: la que hay que volver a pedir. */
  current_version: string | null;
}

const VERSION = /^\d{4}-\d{2}-\d{2}$/;

/**
 * El 400 de los términos, si lo es: `{ code: 'terms_required' | 'terms_outdated',
 * current_version }`. Null para cualquier otra respuesta.
 */
export function readTermsError(status: number, body: unknown): TermsError | null {
  if (status !== 400 || !body || typeof body !== 'object') return null;
  const b = body as Record<string, unknown>;
  const code = b.code ?? b.error;
  if (code !== 'terms_required' && code !== 'terms_outdated') return null;
  const current = typeof b.current_version === 'string' && VERSION.test(b.current_version) ? b.current_version : null;
  return { code, current_version: current };
}
